import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import { useStateIfMounted } from 'use-state-if-mounted';
import {
    actualizarFC_40Estatus, agregarMapFC_40Accion,
    guardarCambiosFC_40Solicitud, obtenerIdCliente,
    resetDataFC_40, actualizarFC_40SolicitudMap, actualizarFC_40Solicitud,
    generarDocumentosFC_40, obtenerFC_40SolicitudDetalle
} from '../../../redux/DucksAtencionACliente/FC_40AtencionAClienteDucks';
import { AcualizarFormatoAccion } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { useDispatch, useSelector } from 'react-redux'
import { host } from '../../../configuraciones'
import { withRouter, Link, NavLink } from 'react-router-dom';
import moment from 'moment'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import estilosFC40 from './AtencionAClientesFC_40Component.module.css'; { {/*Estilos para el componente*/ } }
import { v4 as uuidv4 } from 'uuid';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';

const { useState, useEffect, useRef } = React;
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 290,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FC_40Component(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const modoEdicionBorrador = useSelector(store => store.FC_40Solicitud.modoEdicionBorrador)
    let fc_40 = useSelector(store => store.FC_40SolicitudAtencionACliente.fc_40)
    let solicitud = useSelector(store => store.FC_40SolicitudAtencionACliente.data)
    const formato = useSelector(store => store.AtencionSolicitud.formato)
    let fc_40Map = useSelector(store => store.FC_40SolicitudAtencionACliente.fc_40Map)
    let filesMap = useSelector(store => store.FC_40SolicitudAtencionACliente.filesMap)
    const currentUser = useSelector(store => store.Usuario.data)
    const dataUser = useSelector(store => store.Usuario.user)

    var fechaHoy = moment().format('YYYY-MM-DD');
    const idUsuario = usuario.data.user[0].id
    const idlogin = idUsuario

    let pagina1 = []
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico, idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? !fc_40Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.correoelectronicocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? !fc_40Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.telefonocheck : false,
        },
    )
    if (solicitud.hologramasmezcal) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Hologramas para mezcal', valor: solicitud.hologramasmezcal ? 'Si' : 'No', idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.hologramasmezcal : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? !fc_40Map?.hologramasmezcalcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.hologramasmezcalcheck : false,
            },
            {
                id: uuidv4(), Campo: 'Cantidad para mezcal', valor: solicitud.cantidadmezcal, idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.cantidadmezcal : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? !fc_40Map?.cantidadmezcalcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.cantidadmezcalcheck : false,
            },
        )
    }
    if (solicitud.hologramasbebidasmezcal) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Hologramas para bebidas con mezcal', valor: solicitud.hologramasbebidasmezcal ? 'Si' : 'No', idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.hologramasbebidasmezcal : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? !fc_40Map?.hologramasbebidasmezcalcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.hologramasbebidasmezcalcheck : false,
            },
            {
                id: uuidv4(), Campo: 'Cantidad para bebidas con mezcal', valor: solicitud.cantidadbebidasmezcal, idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.cantidadbebidasmezcal : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? !fc_40Map?.cantidadbebidasmezcalcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_40Map) && JSON.stringify([]) !== JSON.stringify(fc_40Map) ? fc_40Map?.cantidadbebidasmezcalcheck : false,
            },
        )
    }
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)
    let pagina2 = []
    let nameid = 'DGPT'
    let filtro = solicitud.fc_40archivos.filter(anexos => anexos.nameid === nameid)
    const filtroMap = filesMap?.filter(anexo => anexo.idfc_40archivos === filtro[0]?.idfc_40archivos)
    pagina2.push({
        id: uuidv4(),
        observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
        correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
        incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
        fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
        fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
        estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
        idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_40archivosmap : '',
        idfc_40archivos: filtro?.[0]?.idfc_40archivos,
        tabla: 'fc_40archivos', nombreId: 'idfc40_solicitudadquisicionholo', idSolicitud: solicitud.idfc40_solicitudadquisicionholo,
        nameid: nameid, nameDoc: 'Comprobante de pago'
    })

    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)

    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const modoVerDetalle = useSelector(store => store.FC_40SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            rowspagina2[filtroDocumentacion].valor = objectProducto.valor
            rowspagina2[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina2[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroDocumentacion].observaciones = objectProducto.observaciones
        }
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_35())
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_40Map) || JSON.stringify([]) === JSON.stringify(fc_40Map) || fc_40Map === null) {
            await agregarMapYActualizarFC_40()
            const idSolicitud = solicitud.idfc40_solicitudadquisicionholo
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_40 = 11
            const tabla = tablaFC_40
            await dispatch(actualizarFC_40Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_40()
            const idSolicitud = solicitud.idfc40_solicitudadquisicionholo
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_40 = 11
            const tabla = tablaFC_40
            await dispatch(actualizarFC_40Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const agregarMapYActualizarFC_40 = async () => {
        let datosPricipal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        datosPricipal.push({
            idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
            fechasolicitud: fechaSolicitudAceptada
        })
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Cantidad para mezcal') datosPricipal.push({ cantidadmezcal: dato.valor })
            if (dato.Campo === 'Cantidad para bebidas con mezcal') datosPricipal.push({ cantidadbebidasmezcal: dato.valor })
        }
        let principal = {}
        for (const i in datosPricipal) {
            principal = Object.assign(principal, datosPricipal[i])
        }
        let datosPricipalMap = []
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Correo Electrónico') datosPricipalMap.push({ correoelectronico: dato.observaciones, correoelectronicocheck: dato.incorrecto })
            if (dato.Campo === 'Teléfono') datosPricipalMap.push({ telefono: dato.observaciones, telefonocheck: dato.incorrecto })
            if (dato.Campo === 'Hologramas para mezcal') datosPricipalMap.push({ hologramasmezcal: dato.observaciones, hologramasmezcalcheck: dato.incorrecto })
            if (dato.Campo === 'Cantidad para mezcal') datosPricipalMap.push({ cantidadmezcal: dato.observaciones, cantidadmezcalcheck: dato.incorrecto })
            if (dato.Campo === 'Hologramas para bebidas con mezcal') datosPricipalMap.push({ hologramasbebidasmezcal: dato.observaciones, hologramasbebidasmezcalcheck: dato.incorrecto })
            if (dato.Campo === 'Cantidad para bebidas con mezcal') datosPricipalMap.push({ cantidadbebidasmezcal: dato.observaciones, cantidadbebidasmezcalcheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc40_solicitudadquisicionholo = solicitud.idfc40_solicitudadquisicionholo
        let archivosMap = []
        for (const anexo in rowspagina2) {
            archivosMap.push({
                estatuscheck: rowspagina2[anexo]?.incorrecto, observacion: rowspagina2[anexo]?.observaciones,
                idfc_40archivos: rowspagina2[anexo]?.idfc_40archivos,
            })
        }
        let archivos = []
        for (const anexo in rowspagina2) {
            let fechaInicio = ''
            let fechaFin = ''
            if (rowspagina2[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina2[anexo]?.fechaInicio).toISOString()
            else fechaInicio = null
            if (rowspagina2[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina2[anexo]?.fechaTermino).toISOString()
            else fechaFin = null
            archivos.push({
                fechainicio: fechaInicio, fechafin: fechaFin, idfc40_solicitudadquisicionholo: rowspagina2[anexo]?.idSolicitud,
                idfc_40archivos: rowspagina2[anexo]?.idfc_40archivos,
            })
        }
        let formato = { solicitud: principal, archivos: archivos }
        let formatoMap = { solicitud: obj_unidos, archivosMap: archivosMap }
        await dispatch(agregarMapFC_40Accion(formatoMap))
        await dispatch(actualizarFC_40Solicitud(formato))
        return
    }
    const actualizarMapYActualizarFC_40 = async () => {
        let datosPricipal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        datosPricipal.push({
            idfc40_solicitudadquisicionholo: solicitud.idfc40_solicitudadquisicionholo,
            fechasolicitud: fechaSolicitudAceptada
        })
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Cantidad para mezcal') datosPricipal.push({ cantidadmezcal: dato.valor })
            if (dato.Campo === 'Cantidad para bebidas con mezcal') datosPricipal.push({ cantidadbebidasmezcal: dato.valor })
        }
        let principal = {}
        for (const i in datosPricipal) {
            principal = Object.assign(principal, datosPricipal[i])
        }
        let datosPricipalMap = []
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Correo Electrónico') datosPricipalMap.push({ correoelectronico: dato.observaciones, correoelectronicocheck: dato.incorrecto })
            if (dato.Campo === 'Teléfono') datosPricipalMap.push({ telefono: dato.observaciones, telefonocheck: dato.incorrecto })
            if (dato.Campo === 'Hologramas para mezcal') datosPricipalMap.push({ hologramasmezcal: dato.observaciones, hologramasmezcalcheck: dato.incorrecto })
            if (dato.Campo === 'Cantidad para mezcal') datosPricipalMap.push({ cantidadmezcal: dato.observaciones, cantidadmezcalcheck: dato.incorrecto })
            if (dato.Campo === 'Hologramas para bebidas con mezcal') datosPricipalMap.push({ hologramasbebidasmezcal: dato.observaciones, hologramasbebidasmezcalcheck: dato.incorrecto })
            if (dato.Campo === 'Cantidad para bebidas con mezcal') datosPricipalMap.push({ cantidadbebidasmezcal: dato.observaciones, cantidadbebidasmezcalcheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc40_solicitudadquisicionholo = solicitud.idfc40_solicitudadquisicionholo
        obj_unidos.idfc40_solicitudadquisicionholomap = fc_40Map.idfc40_solicitudadquisicionholomap
        let archivosMap = []
        for (const anexo in rowspagina2) {
            archivosMap.push({
                estatuscheck: rowspagina2[anexo]?.incorrecto, observacion: rowspagina2[anexo]?.observaciones,
                idfc_40archivos: rowspagina2[anexo]?.idfc_40archivos, idfc_40archivosmap: rowspagina2[anexo]?.idMap,
            })
        }

        let archivos = []
        for (const anexo in rowspagina2) {
            let fechaInicio = ''
            let fechaFin = ''
            if (rowspagina2[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina2[anexo]?.fechaInicio).toISOString()
            else fechaInicio = null
            if (rowspagina2[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina2[anexo]?.fechaTermino).toISOString()
            else fechaFin = null
            archivos.push({
                fechainicio: fechaInicio, fechafin: fechaFin, idfc40_solicitudadquisicionholo: rowspagina2[anexo]?.idSolicitud,
                idfc_40archivos: rowspagina2[anexo]?.idfc_40archivos,
            })
        }
        let formato = { solicitud: principal, archivos: archivos }
        let formatoMap = { solicitud: obj_unidos, archivosMap: archivosMap }
        await dispatch(actualizarFC_40SolicitudMap(formatoMap))
        await dispatch(actualizarFC_40Solicitud(formato))
        return
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            <strong>Aceptar Solicitud</strong>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'justify' }}>
                            Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                            y los datos se tomarán como válidos.
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                            <strong>¿Desea continuar?</strong>
                        </Typography>
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => botonAceptarSolicitud()}>CONTINUAR</button>
                        </div>

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_40Map) || JSON.stringify([]) === JSON.stringify(fc_40Map) || fc_40Map === null) {
            await agregarMapYActualizarFC_40()
        } else {
            await actualizarMapYActualizarFC_40()
        }
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "12", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: '', origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        let resultado = await dispatch(obtenerFC_40SolicitudDetalle(solicitud.idfc40_solicitudadquisicionholo))
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        await generarOficios(resultado.payload, dataCliente.payload.cliente[0])
        const idSolicitud = solicitud.idfc40_solicitudadquisicionholo
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_40 = 11
        const tabla = tablaFC_40
        await dispatch(actualizarFC_40Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_40, dataCliente) => {
        const data = {
            tipoSolicitud: 'FC_40',
            solicitudFC_40,
            dataCliente,
        }
        await dispatch(generarDocumentosFC_40(data))
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> :
                    <div className='row'>
                        <div className='row justify-content-center'>
                            <div className='col-12' style={{ marginLeft: '7%' }}>
                                <TablaDocumentacion rows={rowspagina2} api={{ handdleEditPrev }}></TablaDocumentacion>
                            </div>
                        </div>
                        {modoVerDetalle ?
                            <div className="row text-center">
                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                    <button type="submit" className={`btn ${estilosFC40.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                </div>
                            </div>
                            :
                            <div className="row text-center mt-4 mb-4">
                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                    <button type="submit" className={`btn ${estilosFC40.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar}>Aceptar solicitud</button>
                                </div>

                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                    <button type="submit" className={`btn ${estilosFC40.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver}>Devolver solicitud</button>
                                </div>
                            </div>
                        }
                    </div>
            }
            {modalComponentDevolver()}
            {modalComponentAceptar()}
        </Fragment>
    )
}

export default withRouter(FC_40Component)
